module.exports = __webpack_public_path__ + "img/szechenyiplus_teszt1.a23d732a.png";